module.exports = __webpack_public_path__ + "img/escudo-ministerio-seguridad.7ddc8c19.png";